import React from 'react';

import HelperPage from 'v2/components/Shared/HelperPage';
import TopPage from 'v2/components/Shared/TopPage';

import ListNotification from './ListNotification';

const Notifications = () => {
  return (
    <>
      <TopPage title='Notificações' extra='Mantenha-se atualizado de todos os status da sua aplicação.' disableAlerts />
      <HelperPage id='list_notification_button' title='Notificações' name='list_notifications' />
      <ListNotification />
    </>
  );
};

export default Notifications;
